// packages/web-ui/src/api/clients/chat.ts
//
// W2-S5 — `postChatMessage` typed wrapper for `POST /api/v1/chat/messages`
// (Arch §3.2 row 229 + §8.6 lines 1180–1206). Returns `Result<T, ApiError>`
// per the API client contract; no throws cross the package boundary.

import type { Result } from '@tessa-lean/base';
import type {
  ChatMessageRequest,
  ChatMessageResponse,
} from '@tessa-lean/base/api-schemas/index.js';
import { apiCall, type ApiContext, type ApiError } from '../client.js';

export type PostChatMessageInput = ChatMessageRequest;
export type PostChatMessageOutput = ChatMessageResponse;

/**
 * POST /api/v1/chat/messages — submit a user message. The server enqueues
 * the message and starts the LLM turn; tokens / tool-calls / final assistant
 * message arrive over the SSE stream the client opened separately.
 */
export async function postChatMessage(
  body: PostChatMessageInput,
  ctx: ApiContext,
): Promise<Result<PostChatMessageOutput, ApiError>> {
  return apiCall<PostChatMessageInput, PostChatMessageOutput>(
    ctx,
    'POST',
    '/api/v1/chat/messages',
    body,
  );
}
